module.exports = __webpack_public_path__ + "static/media/menu-products.2a3ab17d.svg";